import { create } from "zustand";
import axiosInstance from '../../api/axiosInstance';

interface Field {
  type: string;
  value: string;
  link?: string;
}

interface Section {
  id: number;
  section_name: string;
  payload: Record<string, Field>;
}

interface HomeState {
  sections: Record<string, Section>;
  fetchMissionContent: () => Promise<void>;
}

const useMissionStore = create<HomeState>((set) => ({
  sections: {},
  fetchMissionContent: async () => {
    try {
      const response = await axiosInstance.get("/cmsPages/mission");
      const formattedSections = response.data.pages.rows.reduce(
        (acc: Record<string, Section>, section: any) => {
          try {
            // Try to parse the payload
            const parsedPayload = JSON.parse(section.payload);
            acc[section.section_name] = {
              id: section.id,
              section_name: section.section_name,
              payload: parsedPayload,
            };
          } catch (parseError) {
            console.log(section.payload);
            console.error("Error parsing payload for section:", section.section_name, parseError);
          }
          return acc;
        },
        {}
      );

      set({ sections: formattedSections });
    } catch (error) {
      console.error("Error fetching home content:", error);
    }
  },
}));


export default useMissionStore;








